import { render } from "./CodeRecords.vue?vue&type=template&id=b8e43ef4&scoped=true"
import script from "./CodeRecords.vue?vue&type=script&lang=js"
export * from "./CodeRecords.vue?vue&type=script&lang=js"

import "./CodeRecords.vue?vue&type=style&index=0&id=b8e43ef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e43ef4"]])

export default __exports__